import { Handle, Position } from 'reactflow';
import { memo, useContext, useMemo } from 'react';
import { WorkflowContext } from 'providers/workflow-provider';
import Images from 'assets/Images';
import { getValueById, textFormatter } from 'utils';
import './style.scss';
import classNames from 'classnames';
import { HelpIcon } from 'components/generic';

const ActionNode = ({ id, data }) => {
	const context = useContext(WorkflowContext);
	const { addNode, setNodeConfigureIndex, dockerState, edges, handleComponentClick, handleDeleteNode, templateList } = context;
	const templateDropdownList = useMemo(() => templateList?.map(el => ({ key: el?.templateId, value: el?.templateName })), [templateList]);

	const handleAdd = () => {
		dockerState !== 'view' && addNode({ id, data });
	};

	const edgeExists = useMemo(() => edges.some(el => el?.source === id), [edges]);

	const handleSidebar = () => {
		setNodeConfigureIndex(+id);
		handleComponentClick('action');
	};

	const actionList = (
		<ul className='custom-nodes__action'>
			{data?.actionList?.map((el, i) => (
				<li key={i}>
					<div className={classNames({ 'custom-nodes__container': true, 'border-bottom': data?.actionList?.length - i !== 1 })}>
						<div className='align-center'>
							<span>{textFormatter(el?.type)}</span>
							<span>{getValueById(templateDropdownList, el?.templateId)?.value || '-'}</span>
						</div>
					</div>
				</li>
			))}
		</ul>
	);

	return (
		<div className='header-node'>
			<div className='header-node__header space-between'>
				<div className='display-flex'>
					<h6>Action {data?.sendCommunicationAt && '(' + textFormatter(data?.sendCommunicationAt) + ')'} </h6>
					<HelpIcon infoContent='Actions that has be taken if account satisfy conditions' />
				</div>
				<div className='display-flex'>
					<img className='header-node__edit' src={Images['edit-blue']} alt='Edit' onClick={handleSidebar} height='15px' width='15px' />
					{!edgeExists && <img src={Images.deleteBlue} alt='Edit' onClick={() => handleDeleteNode(id)} height='15px' width='15px' />}
				</div>
			</div>
			<div className='header-node__description'>
				<Handle type='target' position={Position.Top} id={`top-${id}`} />
				{data?.actionList?.length > 0 ? actionList : <span>Configuring....</span>}
			</div>
			<Handle type='source' position={Position.Bottom} id={`bottom-${id}`} />
			{!edgeExists && <img className='header-node__add' src={Images?.add} alt='Add' onClick={handleAdd} />}
		</div>
	);
};

export default memo(ActionNode);
